export default [
  { label: 'Publiczny', value: 'PUBLIC' },
  { label: 'Niepubliczny', value: 'NON_PUBLIC' },
]
